import api from '../../common/api';

export const apiGetInitData = (path, lang) => api.appApi.fetch('GET', `/about/api/v1/page/init?path=${path}&lang=${lang}`);
